/* eslint-disable @next/next/next-script-for-ga */
import Script from 'next/script'

export const GTMScript = ({
  servicePageTrackingParams,
}: {
  servicePageTrackingParams?: {
    pageId: string
    audienceId: string
    funnelId: string
  }
}) => {
  return (
    <Script
      strategy="lazyOnload"
      async
      id="gtm-mount-script"
      key="gtm-mount-script"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          ${
            servicePageTrackingParams?.audienceId
              ? `
              window.dataLayer.push({
                audience_name: '${servicePageTrackingParams.audienceId || ''}',
                user_funnel: '${servicePageTrackingParams?.funnelId || ''}',
                project_id: '${servicePageTrackingParams?.pageId || ''}'
              });
          `
              : ''
          }
          function gtag(){dataLayer.push(arguments);}

          (function(w,d,s,l,i){w[l]=w[l]||[];
              w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;d.head.appendChild(j);
              })(window,document,'script','dataLayer','${
                process.env.NEXT_PUBLIC_GTM
              }');`,
      }}
    />
  )
}
